import { render, staticRenderFns } from "./directorys-add.vue?vue&type=template&id=76b2e7cf&scoped=true&"
import script from "./directorys-add.vue?vue&type=script&lang=js&"
export * from "./directorys-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2e7cf",
  null
  
)

export default component.exports